export const selectPond = state => state.pond
